import { render, staticRenderFns } from "./CuponCreate.vue?vue&type=template&id=30aff549&scoped=true&"
import script from "./CuponCreate.vue?vue&type=script&lang=js&"
export * from "./CuponCreate.vue?vue&type=script&lang=js&"
import style0 from "./CuponCreate.vue?vue&type=style&index=0&id=30aff549&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30aff549",
  null
  
)

export default component.exports